class SSOOption {
  constructor(host, appKey, publicKey, privateKey, path) {
    this.host = host;
    this.appKey = appKey;
    this.publicKey = publicKey;
    this.privateKey = privateKey
  }
}
class SSOResult {
  constructor() {
    this.Success = false;
    this.Message = "";
    this.Data = null;
  }
}
class SSOInfo {
  constructor() {
    this.UserID = "";
    this.SessionID = "";
  }
}
class UserProfile {
  constructor() {
    this.id = "";
    this.nickName = "";
    this.avatar = "";
    this.phone = "";
  }
}
export { SSOOption, UserProfile, SSOInfo, SSOResult };
